export function getBookingAuthToken(bookingAuth) {
	if (!bookingAuth) {
		return null;
	}
	if (typeof bookingAuth === 'string') {
		return bookingAuth;
	}
	return bookingAuth.bookingToken || null;
}

export function isBookingAuthorized(bookingAuth) {
	if (bookingAuth == null) {
		return true; // existing logic from confirmation page
	}
	if (typeof bookingAuth === 'string') {
		return bookingAuth.length > 0; // used after booking api in unit reservation page
	}
	return Boolean(
		bookingAuth.isAuthBookingAuth || bookingAuth.isAuthBookingToken,
	);
}
